export default __webpack_public_path__ + "static/media/picto-dl.0a20ec1e.svg";